<div id="login" [ngClass]="wrong ? 'wrong' : ''">
  <div>
    <br />
    <br />
    <br />
  </div>
  <form (submit)="onSubmit($event)" #f="ngForm">
    <div class="input-container">
      <label>Username</label>
      <input clrInput type="text" name="username" [(ngModel)]="username" required aria-label="Username" />
    </div>
    <div class="input-container">
      <label>Password</label>
      <input clrInput type="password" name="password" [(ngModel)]="password" required aria-label="Password" />
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="error_msg">
      <div class="alert-items">
        <div class="alert-item static">
          <div class="alert-icon-wrapper">
            <clr-icon class="alert-icon" shape="exclamation-circle"></clr-icon>
          </div>
          <span class="alert-text">
            {{ error_msg }}
          </span>
        </div>
      </div>
    </div>
    <button type="submit" [disabled]="!f.valid || disabled">Login</button>
  </form>
</div>
